
import React from 'react';

interface PreviewLoaderProps {
  isFullScreen?: boolean;
}

export const PreviewLoader = ({ isFullScreen = false }: PreviewLoaderProps) => {
  return (
    <div 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: isFullScreen ? 'rgba(249, 249, 249, 0.8)' : undefined
      }}
    >
      <div className="h-8 w-8 rounded-full border-4 border-primary border-t-transparent animate-spin"></div>
    </div>
  );
};
